import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propStr } from '../../../../../../helpers/custom-prop-types';
const SolutionError = ({ error }) => {
    if (!error) {
        return null;
    }
    return _jsx("div", Object.assign({ className: 'font-alert' }, { children: error }));
};
SolutionError.propTypes = {
    error: propStr(),
};
SolutionError.defaultProps = {
    error: '',
};
export default SolutionError;
